module.exports = __webpack_public_path__ + "img/icon-crown.53f12819.svg";